var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.0461H24V20.0461C24 18.3893 22.6569 17.0461 21 17.0461C20.0444 17.0461 19.1931 17.4929 18.6438 18.189M19 22.0461H9M19 22.0461V20.0461C19 19.3899 18.8736 18.7632 18.6438 18.189M9 22.0461H4V20.0461C4 18.3893 5.34315 17.0461 7 17.0461C7.95561 17.0461 8.80686 17.4929 9.35625 18.189M9 22.0461V20.0461C9 19.3899 9.12642 18.7632 9.35625 18.189M9.35625 18.189C10.0935 16.3472 11.8948 15.0461 14 15.0461C16.1052 15.0461 17.9065 16.3472 18.6438 18.189M17 9.04614C17 10.703 15.6569 12.0461 14 12.0461C12.3431 12.0461 11 10.703 11 9.04614C11 7.38929 12.3431 6.04614 14 6.04614C15.6569 6.04614 17 7.38929 17 9.04614ZM23 12.0461C23 13.1507 22.1046 14.0461 21 14.0461C19.8954 14.0461 19 13.1507 19 12.0461C19 10.9416 19.8954 10.0461 21 10.0461C22.1046 10.0461 23 10.9416 23 12.0461ZM9 12.0461C9 13.1507 8.10457 14.0461 7 14.0461C5.89543 14.0461 5 13.1507 5 12.0461C5 10.9416 5.89543 10.0461 7 10.0461C8.10457 10.0461 9 10.9416 9 12.0461Z",
    stroke: "#FDFBFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUser);
export default __webpack_public_path__ + "static/media/menu-user.ea994376af800e43b2956514c32fb572.svg";
export { ForwardRef as ReactComponent };